// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import SafetyCertificateTwoToneSvg from "@ant-design/icons-svg/es/asn/SafetyCertificateTwoTone";
import AntdIcon from '../components/AntdIcon';

var SafetyCertificateTwoTone = function SafetyCertificateTwoTone(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: SafetyCertificateTwoToneSvg
  }));
};

SafetyCertificateTwoTone.displayName = 'SafetyCertificateTwoTone';
export default React.forwardRef(SafetyCertificateTwoTone);